// 적 종류 정의
const EnemyTypesConfig = {
  MINION: {
    MODEL_PATH: "models/skeletons/characters/gltf/Skeleton_Minion.glb",
    HEALTH: 20,
    SPEED: 0.035, // 더 빠르게
    ATTACK_RANGE: 1.2,
    ATTACK_DAMAGE: 10,
    ATTACK_COOLTIME: 2.0,
    HIT_STUN_DURATION: 1.4,
    HIT_FLASH_DURATION: 0.7,
    DEATH_ANIMATION_DURATION: 1.0,
    CORPSE_DURATION: 1.5,
    SCALE: 1.2, // 모델 크기
    COLLIDER_RADIUS: 0.5, // 충돌 반경
    KNOCKBACK_STRENGTH: 0.05, // 넉백 거리
    DIAMOND_TYPE: "DIAMOND_BLUE", // 드롭하는 다이아몬드 종류
  },
  ROGUE: {
    MODEL_PATH: "models/skeletons/characters/gltf/Skeleton_Rogue.glb",
    HEALTH: 40,
    SPEED: 0.04, // 매우 빠르게
    ATTACK_RANGE: 1.2,
    ATTACK_DAMAGE: 12,
    ATTACK_COOLTIME: 1.6,
    HIT_STUN_DURATION: 0.5,
    HIT_FLASH_DURATION: 0.2,
    DEATH_ANIMATION_DURATION: 1.0,
    CORPSE_DURATION: 1.0,
    SCALE: 1.25, // 모델 크기
    COLLIDER_RADIUS: 0.5, // 충돌 반경
    KNOCKBACK_STRENGTH: 0.04, // 넉백 거리
    DIAMOND_TYPE: "DIAMOND_YELLOW", // 드롭하는 다이아몬드 종류
  },
  MAGE: {
    MODEL_PATH: "models/skeletons/characters/gltf/Skeleton_Mage.glb",
    HEALTH: 80,
    SPEED: 0.045, // 더 빠르게
    ATTACK_RANGE: 1.2, // 줄임
    ATTACK_DAMAGE: 14,
    ATTACK_COOLTIME: 1.6, // 줄임
    HIT_STUN_DURATION: 0.5,
    HIT_FLASH_DURATION: 0.2,
    DEATH_ANIMATION_DURATION: 1.2,
    CORPSE_DURATION: 2.0,
    SCALE: 1.3, // 모델 크기
    COLLIDER_RADIUS: 0.5, // 충돌 반경
    KNOCKBACK_STRENGTH: 0.03, // 넉백 거리
    DIAMOND_TYPE: "DIAMOND_RED", // 드롭하는 다이아몬드 종류
  },
  WARRIOR: {
    MODEL_PATH: "models/skeletons/characters/gltf/Skeleton_Warrior.glb",
    HEALTH: 2000,
    SPEED: 0.13,
    ATTACK_RANGE: 1.7,
    ATTACK_DAMAGE: 32,
    ATTACK_COOLTIME: 0.2, // 줄임
    HIT_STUN_DURATION: 0.1,
    HIT_FLASH_DURATION: 0.05,
    DEATH_ANIMATION_DURATION: 1.5,
    CORPSE_DURATION: 3.0,
    SCALE: 2.0, // 모델 크기
    COLLIDER_RADIUS: 1.0, // 충돌 반경 (큰 적이라 크게 설정)
    KNOCKBACK_STRENGTH: 0, // 넉백 거리
    DIAMOND_TYPE: "DIAMOND_RED", // 드롭하는 다이아몬드 종류
  },
  CORPSE_DURATION: 1.0,
};

// EnemyConfig는 EnemyTypesConfig를 참조
const EnemyConfig = EnemyTypesConfig;

// webpack 빌드를 위해 default export 추가
export default EnemyConfig;

// 전역 변수로도 등록 (기존 코드 호환성)
window.EnemyConfig = EnemyConfig;
window.EnemyTypesConfig = EnemyTypesConfig;
